import { Tooltip, Zoom, IconButton } from '@mui/material';
import { MdNoteAdd as CreateTicketIcon } from 'react-icons/md';
import { Link } from 'react-router-dom';


let CreateTicket = ({ id }: { id: string }) => {
    return (
        <Tooltip TransitionComponent={Zoom} title="Crea nuovo ticket">
            <IconButton component={Link} color="primary" size="small" to={`/ticket/addnew?emailId=${id}`}>
                <CreateTicketIcon />
            </IconButton>
        </Tooltip>
    )
}

export default CreateTicket;